import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import './multiSelect.css';
import { Border } from 'react-bootstrap-icons';
import { ReactComponent as CustomDownArrow } from '../../assets/icons/DownArrow.svg';
import { ReactComponent as CustomUpArrow } from '../../assets/icons/UpArrow.svg';
import { Chip } from '@mui/material';
import { useState, useEffect, useRef } from 'react';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MultiSearchSelect(props) {
  const [showAllSelected, setShowAllSelected] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleToggleShowAll = () => {
    setShowAllSelected(!showAllSelected);
  };

  const wrapperRef = useRef(null);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowAllSelected(false);
    }
  };

  const handleDropdownOpen = () => {
    setDropdownOpen(true);
  };

  const handleDropdownClose = () => {
    setDropdownOpen(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  let options = props?.option?.map((opt) => ({
    value: opt?.props?.value,
    label: opt?.props?.children
  }));

  const validateInput = () => {
    setIsFocused(false);
    allValidations();
  };

  const validateMandatory = () => {
    if (!props.value || props.value.length === 0) {
      if (!props.mandatoryFields?.includes(props.name)) {
        props.setMandatoryFields && props.setMandatoryFields((prev) => ([...prev, props.name]));
      }
      return "Please provide valid " + props.fieldName;
    } else {
      let mandatoryFieldsTemp = props.mandatoryFields;
      if (mandatoryFieldsTemp?.length > 0) {
        const index = mandatoryFieldsTemp?.indexOf(props.name);
        if (index > -1) {
          mandatoryFieldsTemp.splice(index, 1);
        }
        props.setMandatoryFields && props.setMandatoryFields(mandatoryFieldsTemp);
      }
      return "";
    }
  };

  const allValidations = () => {
    let errorMsg = "";
    if (props?.required && !props?.readOnly) {
      errorMsg = validateMandatory();
    }
    if (errorMsg) {
      props.setError((prev) => ({ ...prev, [props.name]: errorMsg }));
      return;
    } else {
      props.setError((prev) => ({ ...prev, [props.name]: "" }));
    }
    if (props.setError) props.setError((prev) => ({ ...prev, [props.name]: errorMsg }));
  };

  useEffect(() => {
    if (props.required && !props.value && !props.mandatoryFields?.includes(props.name)) {
      props.setMandatoryFields && props.setMandatoryFields((prev) => ([...prev, props.name]));
    }
  }, []);

  useEffect(() => {
    if (props.submit) {
      props.setFieldCount((prev) => ([...prev, props.name]));
      allValidations();
    }
  }, [props.submit]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      props.onChange({ target: { name: props.name, value: props.options } });
    } else {
      props.onChange({ target: { name: props.name, value: [] } });
    }
  };

  const isAllSelected = props.value.length === props.options.length;

  return (
     <div className={`multiSelect ${props.readOnly ? "read-only" : ""} ${props.disabled ? "disabled" : ""}`} ref={wrapperRef}>

    <Autocomplete
      {...props}
        multiple
        disabled={props.disabled}
        className="custom-autocomplete"
        name={props.name}
        label={props.label}
        id="checkboxes-tags-demo"
        options={[...props.options]}
        value={props.value}
        required={props.required}
        // onChange={(event, newValue) => {
        //   props.onChange({ target: { name: props.name, value: newValue } });
        // }}
        onChange={(event, newValue) => {
          if (!props.readOnly) {
            // if (newValue.includes('Select All')) {
            //   if (isAllSelected) {
            //     props.onChange({ target: { name: props.name, value: [] } });
            //   } else {
            //     props.onChange({ target: { name: props.name, value: props.options } });
            //   }
            // } else {
              props.onChange({ target: { name: props.name, value: newValue } });
          //   }
          }
        }}
        disableCloseOnSelect
        getOptionLabel={(option) => option}
        popupIcon={<CustomDownArrow />}
        closeIcon={<CustomUpArrow />}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                // checked={selected}
                // className="custom-checkbox"
                checked={option === 'Select All' ? isAllSelected : selected}
                className="custom-checkbox"
                onChange={option === 'Select All' ? handleSelectAll : undefined}
              />
              {option}
            </li>
          );
        }}
        onOpen={handleDropdownOpen}
        onClose={handleDropdownClose}
        renderTags={(value, getTagProps) => {
          return showAllSelected || dropdownOpen
            ? value.map((option, index) => (
              <Chip key={option} label={option} {...getTagProps({ index })} />
            ))
            : value.length > 2
              ? [
                <Chip key={value[0]} label={value[0]} {...getTagProps({ index: 0 })} />,
                <Chip key={value[1]} label={value[1]} {...getTagProps({ index: 1 })} />,
                <Chip key="more" label={`+${value.length - 2}`} onClick={handleToggleShowAll} />,
              ]
              : value.map((option, index) => (
                <Chip key={option} label={option} {...getTagProps({ index })} />
              ));
        }}
        renderInput={(params) => (
          <div className='multi-record-scroll'>
          <TextField
            {...params}
            label={props.label}
            helperText={isFocused && !props.readOnly && !props.error ? props.hint : ''}
            onFocus={(e) => {
              setIsFocused(true);
              if (props.onFocus) props.onFocus(e);
            }}
            onBlur={(e) => {
              validateInput();
              if (props.onBlur) props.onBlur(e);
            }}
            disabled={props.disabled}
          />
          </div>
        )}
      />
      {props.error && <div className="error">{props.error}</div>}
    </div>
  );
}
